import axios from "axios";
import { FILE_UPLOAD_API } from "@/utils/upload";

const uploadFileApiURL = FILE_UPLOAD_API + "get-pre-signed-url";

export const uploadService = {
  async uploadFile(file, fileName) {
    try {
      // First step: Get the pre-signed POST URL
      const initialResponse = await axios.post(
        uploadFileApiURL,
        { fileName: fileName },
        { headers: { "Content-Type": "application/json" } }
      );
      const postData = initialResponse.data;
      const postURL = postData.upload.url;
      const postFields = postData.upload.fields;

      // Create form data for the upload
      const formData = new FormData();
      Object.entries(postFields).forEach(([key, value]) => {
        formData.append(key, value);
      });
      formData.append("file", new File([file], fileName));

      // Second step: Upload the file to the presigned POST URL
      await axios.post(postURL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      return postData.download;
    } catch (err) {}
  },
};
